import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface LiveNumberProps {
  value: number;
  className?: string;
}

/** A number that slides/fades whenever it changes, so live updates are noticed. */
export function LiveNumber({
  value,
  className = ''
}: LiveNumberProps) {
  return <span className={`relative inline-flex overflow-hidden align-baseline ${className}`} data-id="element-163" data-mp="18z37cz7vvla4">
      <AnimatePresence mode="popLayout" initial={false} data-id="element-164" data-mp="u2lw07zp26nk">
        <motion.span key={value} initial={{
        y: '75%',
        opacity: 0
      }} animate={{
        y: '0%',
        opacity: 1
      }} exit={{
        y: '-75%',
        opacity: 0,
        position: 'absolute'
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="tabular-nums" data-id="element-165" data-mp="u114kr8of3tx">
          {value}
        </motion.span>
      </AnimatePresence>
    </span>;
}